import styled from "@emotion/styled";
import { colors } from "../../constants";

export const NavBarContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 50;
  left: 0;
  top: 0;
  gap: 5rem;
  user-select: none;
  -webkit-user-drag: none;
  padding: 10vh;
  width: 100%;
  transition: background-color 0.25s ease, padding 0.4s ease;
  max-height: 70px;
  overflow: hidden;
  padding: ${(props) => (props.hasScrolled ? "5vh" : "10vh")};
  background-color: ${(props) =>
    props.hasScrolled ? colors.secondaryRedTransparent : "transparent"};
  backdrop-filter: ${(props) => (props.hasScrolled ? "blur(8px)" : "none")};

  @media (max-width: 768px) {
    gap: 2rem;
  }

  @media (max-width: 500px) {
    flex-direction: column;
    gap: 0.2rem;
  }
`;

export const NavLink = styled.a`
  text-decoration: none;
  font-size: 1rem;
  font-weight: 900;
  color: ${colors.neutralDark};
  cursor: pointer;
  font-size: clamp(1rem, 2.5vw + 0.5rem, 1.2rem);
  text-transform: uppercase;

  &:first-of-type {
    margin-top: 0.2rem;
  }
`;

export const Logo = styled.img`
  max-height: 50px;
  height: auto;
  width: auto;
  margin: 0 10px;

  @media (max-width: 768px), (max-width: 500px) {
    display: none;
  }
`;
